// While the operator has the show paused, every countdown holds where it was; when it resumes the scene's
// countdown arrives again from the engine (re-latched by the badges, which otherwise keep their first value).
let pausedAt = null;
const listeners = new Set();

export const setShowPaused = (paused) => {
    if (!!paused === (pausedAt != null)) return;
    if (paused) pausedAt = Date.now();
    else pausedAt = null;
    listeners.forEach(fn => fn());
};

// The time a countdown should read: frozen at the pause.
export const countdownNow = (clockDrift = 0) => (pausedAt != null ? pausedAt : Date.now()) + clockDrift;
export const isShowPaused = () => pausedAt != null;
export const onShowPause = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
